export const ACTIONS = {
  EDIT_DATA: 'editData',
};

export const STEPS = {
  ACTIONS_SELECTOR: 1,
  COMPETITOR_SELECTOR: 2,
};
